import { BasicModel } from '../../../../shared/domain/models/BasicModel';
import { StatusType } from '../../data/entities/StatusEntity';

export class StatusModel extends BasicModel {
  type: StatusType;

  constructor({
    id,
    name,
    type
  }: {
    id: string;
    name: string;
    type: StatusType;
  }) {
    super({ id, name });
    this.type = type;
  }
}
